import React from 'react'

import {
    Content,
    ContentImage,
    ContentImageT,
    ContentImageM,
    OverContainerSection,
    Back,
} from './styles'
import { EntryFields } from 'types/contenfull'
import BackButton from 'src/components/common/BackButton/BackButton'
import Desktop from 'src/assets/Blog/headerd.avif'
import Tablet from 'src/assets/Blog/headert.avif'
import Mobile from 'src/assets/Blog/headerm.avif'

interface ProfileSectionProps {
    Blog: EntryFields
}

export const BlogSection = ({ Blog }: ProfileSectionProps) => {
    return (
        <OverContainerSection>
            <Content>
                <ContentImage src={Desktop} alt={Blog.tittleContent} />
                <ContentImageT src={Tablet} alt={Blog.tittleContent} />
                <ContentImageM src={Mobile} alt={Blog.tittleContent} />
                <Back marginTop={['xxmedium', 'xxmedium', 'medium', 'xlarge']}>
                    <BackButton />
                </Back>
            </Content>
        </OverContainerSection>
    )
}
